import React, { useEffect, useState, useRef } from 'react';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import ReactCardFlip from 'react-card-flip';

const CustomFlipCard = ({ data }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const handleMouseEnter = () => {
      setIsFlipped(true);
    };

    const handleMouseLeave = () => {
      setIsFlipped(false);
    };

    cardRef.current.addEventListener('mouseenter', handleMouseEnter);
    cardRef.current.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <Box ref={cardRef}>
      <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
        <Flex
          height={'300px'}
          width={'300px'}
          boxShadow={'-4px 6px 3px #d0d0d0'}
          border={'2px solid #efefef'}
          bg={'white'}
        >
          <Box
            display={'flex'}
            w={'100%'}
            h={'100%'}
            justifyContent="center"
            alignItems={'center'}
          >
            <Image bg={'white'} src={data.logo} objectFit={'cover'} />
          </Box>
        </Flex>
        <Flex
          height={'300px'}
          width={'300px'}
          boxShadow={'-4px 6px 3px #d0d0d0'}
          border={'2px solid #efefef'}
          bg={'white'}
          justifyContent="center"
          alignItems={'center'}
          p={'1.3rem'}
        >
          <Text fontSize={'0.9rem'}>&quot;{data.testimonial}&quot;</Text>
        </Flex>
      </ReactCardFlip>
    </Box>
  );
};

export default CustomFlipCard;
